import React from 'react';
import { PhoneIcon, MapPinIcon, ClockIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black text-white py-12 border-t-4 border-[#B1050B]" data-id="element-515">
      <div className="container mx-auto px-4" data-id="element-516">
        <div className="max-w-5xl mx-auto" data-id="element-517">
          <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-518">
            <div data-id="element-519">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vgAD6BMFW6FPpPWQURJJHv/logo_black_bg.jpg" alt="Garrett Auto & Truck Service Logo" className="w-48 h-auto mb-4 rounded border-2 border-[#D4AF37]" data-id="element-520" />
              <h3 className="text-xl font-bold mb-4" data-id="element-521">
                Garrett Auto and Truck Service, Inc
              </h3>
              <p className="text-white mb-4" data-id="element-522">
                Expert automotive and truck repair services in Farmington Hills
                since 1958.
              </p>
            </div>
            <div data-id="element-523">
              <h3 className="text-xl font-bold mb-4" data-id="element-524">Quick Links</h3>
              <ul className="space-y-2" data-id="element-525">
                <li data-id="element-526">
                  <a href="#home" className="text-white hover:text-[#B1050B] transition-colors" data-id="element-527">
                    Home
                  </a>
                </li>
                <li data-id="element-528">
                  <a href="#about" className="text-white hover:text-[#B1050B] transition-colors" data-id="element-529">
                    About
                  </a>
                </li>
                <li data-id="element-530">
                  <a href="#services" className="text-white hover:text-[#B1050B] transition-colors" data-id="element-531">
                    Services
                  </a>
                </li>
                <li data-id="element-532">
                  <a href="#dot-cdl" className="text-white hover:text-[#B1050B] transition-colors" data-id="element-533">
                    DOT & CDL
                  </a>
                </li>
                <li data-id="element-534">
                  <a href="#trailer-rv" className="text-white hover:text-[#B1050B] transition-colors" data-id="element-535">
                    Trailer & RV
                  </a>
                </li>
                <li data-id="element-536">
                  <a href="#contact" className="text-white hover:text-[#B1050B] transition-colors" data-id="element-537">
                    Contact
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-538">
              <h3 className="text-xl font-bold mb-4" data-id="element-539">Contact Info</h3>
              <div className="space-y-3" data-id="element-540">
                <p className="flex items-center text-white" data-id="element-541">
                  <PhoneIcon size={18} className="mr-2 text-[#B1050B]" data-id="element-542" />
                  <a href="tel:2484788382" className="hover:text-[#B1050B] transition-colors" data-id="element-543">
                    (248) 478-8382
                  </a>
                </p>
                <p className="flex items-start text-white" data-id="element-544">
                  <MapPinIcon size={18} className="mr-2 mt-1 text-[#B1050B]" data-id="element-545" />
                  <span data-id="element-546">
                    24175 Industrial Park Dr.
                    <br data-id="element-547" />
                    Farmington Hills, MI 48335
                  </span>
                </p>
                <p className="flex items-start text-white" data-id="element-548">
                  <ClockIcon size={18} className="mr-2 mt-1 text-[#B1050B]" data-id="element-549" />
                  <span data-id="element-550">Mon-Fri: 7:00 AM - 4:00 PM</span>
                </p>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-6 text-center" data-id="element-551">
            <p className="text-white" data-id="element-552">
              &copy; {new Date().getFullYear()} Garrett Auto and Truck Service,
              Inc. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}